import styles from './Header.module.css';
const Header = (props) => {
    return (<div class={styles.header}>
      <span class={styles.title}>
        {props.children}
      </span>
    </div>);
};
export default Header;
